import { Schema } from 'effect';
import { Location2DSchema } from './location';

export const DeliveryPointIdSchema = Schema.String;
export type DeliveryPointId = Schema.Schema.Type<typeof DeliveryPointIdSchema>;

export const DeliveryPointSchema = Schema.Struct({
  id: DeliveryPointIdSchema,
  name: Schema.String,
  location: Location2DSchema
});
export type DeliveryPoint = Schema.Schema.Type<typeof DeliveryPointSchema>;
